export type ArchiveKind = 'exercises' | 'programs'
export type ArchiveSort = 'id' | 'name' | 'updated_at'

export type ArchiveFilters = {
	kind: ArchiveKind
	search: string
	sort: ArchiveSort
	direction: 'asc' | 'desc'
	limit: number
}

export const defaultArchiveFilters: ArchiveFilters = {
	kind: 'exercises',
	search: '',
	sort: 'updated_at',
	direction: 'desc',
	limit: 25,
}

const validKinds = new Set<ArchiveKind>(['exercises', 'programs'])
const validSorts = new Set<ArchiveSort>(['id', 'name', 'updated_at'])

export const parseArchiveFilters = (search: string): ArchiveFilters => {
	const params = new URLSearchParams(search)
	const kind = params.get('kind') as ArchiveKind | null
	const sort = params.get('sort') as ArchiveSort | null
	const direction = params.get('direction')
	const limit = Number(params.get('limit'))
	return {
		kind: kind && validKinds.has(kind) ? kind : defaultArchiveFilters.kind,
		search: params.get('search') ?? '',
		sort: sort && validSorts.has(sort) ? sort : defaultArchiveFilters.sort,
		direction: direction === 'asc' || direction === 'desc' ? direction : defaultArchiveFilters.direction,
		limit: Number.isInteger(limit) && limit >= 10 && limit <= 100 ? limit : defaultArchiveFilters.limit,
	}
}

export const serializeArchiveFilters = (filters: ArchiveFilters) => {
	const params = new URLSearchParams()
	if (filters.kind !== defaultArchiveFilters.kind) params.set('kind', filters.kind)
	if (filters.search.trim()) params.set('search', filters.search.trim())
	if (filters.sort !== defaultArchiveFilters.sort) params.set('sort', filters.sort)
	if (filters.direction !== defaultArchiveFilters.direction) params.set('direction', filters.direction)
	if (filters.limit !== defaultArchiveFilters.limit) params.set('limit', String(filters.limit))
	const value = params.toString()
	return value ? `?${value}` : ''
}
